import { render, staticRenderFns } from "./fb_full_editor.vue?vue&type=template&id=3bac8752&"
import script from "./fb_full_editor.vue?vue&type=script&lang=js&"
export * from "./fb_full_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bac8752')) {
      api.createRecord('3bac8752', component.options)
    } else {
      api.reload('3bac8752', component.options)
    }
    module.hot.accept("./fb_full_editor.vue?vue&type=template&id=3bac8752&", function () {
      api.rerender('3bac8752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/fb_full_editor.vue"
export default component.exports